import(/* webpackMode: "eager" */ "/app/src/app/code-lab/[trackSlug]/page.tsx");
